import { render, staticRenderFns } from "./completedCard.vue?vue&type=template&id=0af9efd2&scoped=true&"
import script from "./completedCard.vue?vue&type=script&lang=js&"
export * from "./completedCard.vue?vue&type=script&lang=js&"
import style0 from "./completedCard.vue?vue&type=style&index=0&id=0af9efd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af9efd2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
